import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { SettingsActions } from './settings.actions';
import { initialSettingsState } from './settings.models';

const reducer = createReducer(
  initialSettingsState,

  on(SettingsActions.resetSettings, () => initialSettingsState),

  on(
    SettingsActions.homescreenInitialized,
    SettingsActions.homescreenUpdated,
    (state, { homescreen }) => ({ ...state, homescreen }),
  ),

  on(SettingsActions.toggleCanteenRemember, (state, { enabled }) => ({
    ...state,
    canteen: { ...state.canteen, remember: enabled },
  })),
  on(SettingsActions.changeRememberedCanteen, (state, { canteenId }) => ({
    ...state,
    canteen: { ...state.canteen, rememberedId: canteenId },
  })),

  on(SettingsActions.toggleDepartureRemember, (state, { enabled }) => ({
    ...state,
    departureStation: { ...state.departureStation, remember: enabled },
  })),
  on(SettingsActions.changeRememberedStation, (state, { stationId }) => ({
    ...state,
    departureStation: { ...state.departureStation, rememberedId: stationId },
  })),

  on(SettingsActions.changeRememberedNaviCategories, (state, { categories }) => ({
    ...state,
    campusNavi: { rememberedCategories: categories },
  })),

  on(SettingsActions.togglePush, (state, { enabled }) => ({
    ...state,
    push: { ...state.push, enabled },
  })),
  on(SettingsActions.togglePushChannel, (state, { channel, enabled }) => ({
    ...state,
    push: { ...state.push, channel: { ...state.push.channel, [channel]: enabled } },
  })),

  on(SettingsActions.toggleWeather, (state, { enabled }) => ({
    ...state,
    weather: { ...state.weather, enabled },
  })),
  on(SettingsActions.changeWeatherStyle, (state, { style }) => ({
    ...state,
    weather: { ...state.weather, style },
  })),
  on(SettingsActions.changeWeatherWindUnit, (state, { windUnit }) => ({
    ...state,
    weather: { ...state.weather, windUnit },
  })),

  on(SettingsActions.changeLanguage, (state, { language }) => ({ ...state, language })),

  on(SettingsActions.updatePersonalContactDetails, (state, { personalContactDetails }) => ({
    ...state,
    personalContactDetails: { ...state.personalContactDetails, ...personalContactDetails },
  })),
);

/**
 * `createFeature` derives one selector per top-level field (`selectCanteen`,
 * `selectHomescreen`, `selectPush`, …) plus `selectSettingsState`. Only the
 * drill-downs below have to be written by hand.
 */
export const settingsFeature = createFeature({
  name: 'settings',
  reducer,
  extraSelectors: ({ selectCanteen, selectDepartureStation, selectCampusNavi, selectPush, selectWeather, selectLanguage }) => ({
    selectCanteenRemember: createSelector(selectCanteen, canteen => canteen.remember),
    selectCanteenRememberedId: createSelector(selectCanteen, canteen => canteen.rememberedId),

    selectDepartureRemember: createSelector(selectDepartureStation, departure => departure.remember),
    selectDepartureRememberedId: createSelector(selectDepartureStation, departure => departure.rememberedId),

    selectCampusNaviRememberedCategories: createSelector(
      selectCampusNavi,
      campusNavi => campusNavi.rememberedCategories,
    ),

    selectPushEnabled: createSelector(selectPush, push => push.enabled),
    /**
     * The whole channel map. Read a single channel via `selectPushChannels()[channel]`
     * rather than through a selector factory — a factory builds a fresh, unmemoised
     * selector on every call, which in a template means one per change detection run.
     */
    selectPushChannels: createSelector(selectPush, push => push.channel),

    selectWeatherEnabled: createSelector(selectWeather, weather => weather.enabled),
    selectWeatherStyle: createSelector(selectWeather, weather => weather.style),
    selectWeatherWindUnit: createSelector(selectWeather, weather => weather.windUnit),
  }),
});
